import { Link } from '@dbt-labs/sourdough';

const getLinkedEnvironment = (link: string | undefined) => {
  return link ? (
    <Link isInternal={false} shouldOpenNewTab={true} to={link}>
      environment settings
    </Link>
  ) : (
    'environment settings'
  );
};

export const getNotEnabledMessage = (
  isAdmin: boolean,
  hasDeveloperLicense: boolean,
  link: string | undefined,
) => {
  const message = (
    <>
      {'As a Developer seat, you may be able to enable this feature in your '}
      {getLinkedEnvironment(link)}
      {
        '. If the permissions do not work, seek out your warehouse and/or dbt admin for help.'
      }
    </>
  );

  return isAdmin || hasDeveloperLicense ? (
    message
  ) : (
    <>
      As a <b>Read</b> seat, you'll need to speak with your warehouse and/or dbt admin
      for help. Send them this{' '}
      <Link
        isInternal={false}
        to="https://docs.getdbt.com/docs/collaborate/model-query-history#enable-query-history-in-dbt-cloud"
        onClick={(e) => e.stopPropagation()}
        shouldOpenNewTab
      >
        link
      </Link>{' '}
      so they can learn how to enable the feature for you and your team.
    </>
  );
};
